import { getWards } from '@/modules/Employee/services'
import { FilterSelect } from '@/components/ui/filters'
import { useQuery } from '@tanstack/react-query'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface WardSelectProps<T extends FieldValues> {
    state: string
    district: string
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    multiple?: boolean
    disabled?: boolean
    label?: string
    onChangeAfterHookForm?: () => void
}

const WardSelect = <T extends FieldValues>({
    state,
    district,
    control,
    name,
    multiple,
    label,
    disabled = false,
    onChangeAfterHookForm,
}: WardSelectProps<T>) => {
    const { data: wards } = useQuery({
        queryKey: [QUERY_KEYS.WARDS, state, district],
        queryFn: () => getWards({ state, district }),
        enabled: !!state && !!district,
    })
    const { t } = useTranslation()
    return (
        <FilterSelect
            control={control}
            name={name}
            label={t(label || 'ward')}
            placeholder={t(label || 'ward')}
            options={wards || []}
            showClearButton={false}
            disabled={disabled}
            multiple={multiple}
            onChangeAfterHookForm={onChangeAfterHookForm}
        />
    )
}

export default WardSelect
